module.exports = __webpack_public_path__ + "static/media/designbyhumans.74c641cc.svg";